<template>
    <Formable :label="`${labelText}：`">
        <div>{{ textDesc }}</div>
    </Formable>
</template>
<script>
import Formable from '@ks/sharp-comp-formable';
export default {
    components: {
        Formable,
    },
    props: {
        labelText: {
            type: String,
            default: '',
        },
        textDesc: {
            type: String,
            default: '',
        },
    },
};
</script>
